import React from 'react';
const Container = ({children}) => {
    return ( 
        <div className='container mx-auto pr-2 pl-2' >{children} </div>
     );
}
 
export default Container;